<yo-help lang="fr" [file]="pathFile" [dialogMsgSupplier]="dialogMsgSupplier()" [width]="800"></yo-help>
